angular.module('unica_hotel.hotel_services')

.factory('HotelDeleteService', function ($http, getBaseApiURL) {

	var hotelDeleteService = {};

	hotelDeleteService.delete = function (hotelId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/hotel/delete/' + hotelId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return hotelDeleteService;
});